var _style, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgLogo(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 112 49",
    style: {
      enableBackground: "new 0 0 112 49"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:#FFFFFF;}\n")), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M18.7,31.1H16l-6-9.3v9.3H7.1V16h2.6l6,9.2V16h2.9V31.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M31,31.1h-2.7v-1c-0.7,0.8-1.6,1.1-2.8,1.1c-1.1,0-2-0.3-2.6-1c-0.7-0.7-1.1-1.8-1.1-3.1V20h2.8v6.7 c0,0.7,0.2,1.2,0.5,1.5c0.4,0.3,0.8,0.5,1.3,0.5c0.5,0,0.9-0.2,1.3-0.5c0.4-0.3,0.5-0.8,0.5-1.5V20H31V31.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M39.1,31.1h-1.5c-1,0-1.8-0.3-2.4-0.9c-0.5-0.6-0.8-1.4-0.8-2.2v-5.5h-1.2v-2.1h1.2v-3.3h2.8v3.3h2v2.1h-2v5.3 c0,0.7,0.3,1,1,1h1V31.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M49.7,21l-2.1,2.1c-0.4-0.4-0.9-0.7-1.5-0.7c-0.5,0-0.9,0.2-1.2,0.5c-0.4,0.4-0.5,0.9-0.5,1.5v6.7h-2.8V20h2.7 v1.1c0.3-0.3,0.7-0.6,1.2-0.8c0.5-0.2,1-0.3,1.6-0.3C48.1,19.9,49,20.3,49.7,21z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M54,18.2h-2.8v-2.2H54V18.2z M54,31.1h-2.8V20H54V31.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M65.4,27.6c0,1.2-0.4,2.1-1.3,2.7c-0.9,0.6-2,0.9-3.4,0.9c-1,0-1.9-0.1-2.6-0.3c-0.7-0.2-1.4-0.6-2.1-1.3 l1.8-1.8c0.7,0.7,1.7,1,2.9,1c0.5,0,1-0.1,1.4-0.3c0.4-0.2,0.6-0.5,0.6-0.9c0-0.6-0.4-0.9-1.2-1l-1.7-0.2c-2.1-0.2-3.2-1.2-3.2-3.1 c0-1.1,0.4-2,1.2-2.6c0.8-0.6,1.8-0.9,3-0.9c1.9,0,3.3,0.4,4.2,1.3l-1.7,1.7c-0.6-0.5-1.4-0.7-2.6-0.7c-0.5,0-0.9,0.1-1.2,0.3 c-0.3,0.2-0.4,0.5-0.4,0.8c0,0.6,0.4,0.9,1.1,1l1.7,0.2c1.1,0.1,1.9,0.4,2.4,1S65.4,26.7,65.4,27.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M76.9,23.8c0,0.4,0,1,0,1.7c0,0.7,0,1.3,0,1.8c0,0.4-0.1,0.9-0.3,1.5c-0.2,0.6-0.4,1-0.8,1.4 c-0.7,0.7-1.6,1-2.7,1c-1.1,0-2-0.4-2.7-1.1v5h-2.8V20h2.7v1c0.7-0.8,1.6-1.2,2.8-1.2c1.1,0,2,0.3,2.7,1c0.3,0.3,0.6,0.8,0.8,1.4 S76.9,23.4,76.9,23.8z M74.2,25.6c0-1-0.1-1.8-0.4-2.4c-0.2-0.5-0.7-0.8-1.5-0.8c-0.8,0-1.3,0.3-1.5,0.8c-0.2,0.5-0.4,1.3-0.4,2.4 c0,0.5,0,0.9,0.1,1.3c0,0.3,0.1,0.7,0.2,1c0.1,0.3,0.3,0.5,0.6,0.7c0.3,0.2,0.6,0.2,1,0.2c0.4,0,0.7-0.1,1-0.2 c0.3-0.2,0.5-0.4,0.6-0.7c0.1-0.3,0.2-0.6,0.2-1C74.2,26.5,74.2,26.1,74.2,25.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M88.5,25.6c0,1.1-0.1,1.9-0.3,2.6c-0.2,0.7-0.5,1.2-1,1.7c-0.8,0.9-2,1.4-3.4,1.4c-1.4,0-2.6-0.5-3.4-1.4 c-0.5-0.5-0.8-1.1-1-1.7c-0.2-0.7-0.3-1.5-0.3-2.6c0-1,0.1-1.9,0.3-2.6c0.2-0.7,0.5-1.2,1-1.7c0.8-0.9,2-1.4,3.4-1.4 c1.4,0,2.6,0.5,3.4,1.4c0.5,0.5,0.8,1.1,1,1.7C88.4,23.7,88.5,24.5,88.5,25.6z M85.7,25.6c0-1.4-0.2-2.2-0.6-2.7 c-0.3-0.3-0.8-0.5-1.3-0.5c-0.5,0-0.9,0.2-1.3,0.5c-0.4,0.4-0.6,1.3-0.6,2.7c0,1.4,0.2,2.3,0.6,2.7c0.3,0.3,0.7,0.5,1.3,0.5 c0.5,0,1-0.2,1.3-0.5C85.5,27.8,85.7,26.9,85.7,25.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M99.2,21l-2.1,2.1c-0.4-0.4-0.9-0.7-1.5-0.7c-0.5,0-0.9,0.2-1.2,0.5s-0.5,0.9-0.5,1.5v6.7h-2.8V20h2.7v1.1 c0.3-0.3,0.7-0.6,1.2-0.8c0.5-0.2,1-0.3,1.6-0.3C97.6,19.9,98.5,20.3,99.2,21z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M105.7,31.1h-1.5c-1,0-1.8-0.3-2.4-0.9c-0.5-0.6-0.8-1.4-0.8-2.2v-5.5h-1.2v-2.1h1.2v-3.3h2.8v3.3h2v2.1h-2 v5.3c0,0.7,0.3,1,1,1h1V31.1z"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogo);
export default __webpack_public_path__ + "static/media/logo.8c3b36b9ff0b0259f71ed72a7b35e947.svg";
export { ForwardRef as ReactComponent };